import { createAction, props } from '@ngrx/store';
import { DocumentGroup, NewsItem, PriceList } from 'src/app/generated/CrossPoint.Sales.Server';
import { ApiPermissions } from 'src/app/utils/interfaces/auth.interfaces';
import { IGetNewsItems, IGetPriceLists, ISetPriceLists } from 'src/app/utils/interfaces/remote-maintenance.interfaces';
import { IDataAction } from '../../utils/interfaces/common.interfaces';

export enum SalesActionsTypes {
  GET_AUTH_INFO_SALES = '[AUTH] AUTH_INFO_SALES',
  GET_AUTH_INFO_SALES_SUCCESS = '[AUTH] AUTH_INFO_SALES_SUCCESS',
  GET_AUTH_INFO_SALES_FAILED = '[AUTH] AUTH_INFO_SALES_FAILED',

  GET_NEWS = '[SALES] GET_NEWS',
  GET_NEWS_SUCCESS = '[SALES] GET_NEWS_SUCCESS',
  GET_NEWS_FAILED = '[SALES] GET_NEWS_FAILED',

  GET_PRICELISTS = '[SALES] GET_PRICELISTS',
  GET_PRICELISTS_SUCCESS = '[SALES] GET_PRICELISTS_SUCCESS',
  GET_PRICELISTS_FAILED = '[SALES] GET_PRICELISTS_FAILED',

  GET_DOCUMENTS = '[SALES] GET_DOCUMENTS',
  GET_DOCUMENTS_SUCCESS = '[SALES] GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_FAILED = '[SALES] GET_DOCUMENTS_FAILED',
}

export const getAuthInfoSalesAction = createAction(SalesActionsTypes.GET_AUTH_INFO_SALES);
export const getAuthInfoSalesSuccessAction = createAction(SalesActionsTypes.GET_AUTH_INFO_SALES_SUCCESS, props<IDataAction<ApiPermissions>>());
export const getAuthInfoSalesFailedAction = createAction(SalesActionsTypes.GET_AUTH_INFO_SALES_FAILED);

export const getNewsAction = createAction(SalesActionsTypes.GET_NEWS, props<IDataAction<IGetNewsItems>>());
export const getNewsSuccessAction = createAction(SalesActionsTypes.GET_NEWS_SUCCESS, props<IDataAction<NewsItem[]>>());
export const getNewsFailedAction = createAction(SalesActionsTypes.GET_NEWS_FAILED);

export const getPriceListsAction = createAction(SalesActionsTypes.GET_PRICELISTS, props<IDataAction<IGetPriceLists>>());
export const getPriceListsSuccessAction = createAction(SalesActionsTypes.GET_PRICELISTS_SUCCESS, props<IDataAction<PriceList>>());
export const getPriceListsFailedAction = createAction(SalesActionsTypes.GET_PRICELISTS_FAILED);

export const getDocumentsAction = createAction(SalesActionsTypes.GET_DOCUMENTS);
export const getDocumentsSuccessAction = createAction(SalesActionsTypes.GET_DOCUMENTS_SUCCESS, props<IDataAction<DocumentGroup[]>>());
export const getDocumentsFailedAction = createAction(SalesActionsTypes.GET_DOCUMENTS_FAILED);